module.exports = __webpack_public_path__ + "img/paybox-no-recommendation.08793ded.png";